import script from "./ModeratorRequestTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorRequestTableItem.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorRequestTableItem.vue?vue&type=style&index=0&id=aab0f8d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab0f8d6"]])

export default __exports__